import { PlansItemContainer } from "./Plans.styled";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";
import { PricingActualPlans } from "../../../interfaces";

interface PlansItemProps {
	title: string;
	isActive: boolean;
	value: number;
}

export const PlansItem = observer(({ title, isActive, value }: PlansItemProps) => {
	const { pricingActualStore } = useStores();

	const handleOnChangePlan = () => {
		pricingActualStore.setPlans(title as PricingActualPlans);
		pricingActualStore.setPlanId(value);
	};

	return (
		<PlansItemContainer isActive={isActive} onClick={handleOnChangePlan}>
			{title}
		</PlansItemContainer>
	);
});
